import * as React from "react";
const SvgFiRrTruckContainerEmpty = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m23.641 10.76-.901-2.704A4.46 4.46 0 0 0 18.501 5a2.503 2.503 0 0 0-2.5 2.5V17H1a1 1 0 0 0-1 1v1.5c0 .987.42 1.933 1.152 2.596a3.51 3.51 0 0 0 2.706.886 3.4 3.4 0 0 0 2.119-1.059A3.5 3.5 0 0 0 8.5 23c1.93 0 3.5-1.57 3.5-3.5V19h4v.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5v-.769A2 2 0 0 0 24 17v-4.026c0-.753-.121-1.498-.359-2.214M18 17v-4h4v4zm.5-10c1.064 0 2.005.679 2.342 1.688L21.613 11h-3.612V7.5A.5.5 0 0 1 18.5 7M3.659 20.992a1.5 1.5 0 0 1-1.165-.38A1.48 1.48 0 0 1 2 19.5V19h3v.357c0 .841-.589 1.56-1.341 1.635M10 19.5c0 .827-.673 1.5-1.5 1.5S7 20.327 7 19.5V19h3zm9.5 1.5c-.827 0-1.5-.673-1.5-1.5V19h3v.5c0 .827-.673 1.5-1.5 1.5"
    />
  </svg>
);
export default SvgFiRrTruckContainerEmpty;
